<template>
    <div class="container-mp"
    @touchstart="touchStartHandler"
    @touchend="touchEndHandler">
        <div class="lucida-icon-mp">
            <img src="../../assets/image/index_v2/Group.svg" alt="">
        </div>
        <div class="main-box-mp">
            <div class="title-mp">
                <div><span class="emphasize-mp">Lucida is a</span></div>
                <div>multi-strategy</div>
                <div>hedge fund</div>
                <div>built for</div>
                <div><span class="emphasize-mp">Crypto trading</span></div>
            </div>
            <div class="user-info-mp">
                <div class="info-item-mp">
                    It has leading performance in arbitrage,<br />
                    market-making, and directional strategies.
                </div>
                <div class="info-item-mp">
                    Its team consists of over 20 experienced<br />
                    researchers and asset managers based in<br />
                    Hong Kong, London and New York.
                </div>
                <div class="info-item-mp">
                    Lucida was founded in 2018<br />
                    by Naiqian Zheng
                </div>
                <div class="info-item-mp">
                    and its co-managing partners is<br />
                    Fabian Bjorklund
                </div>
            </div>
            <div class="contact-info-mp">
                <div class="line-left-mp"></div>
                <div class="contact-item-mp">
                    <span>For inquiries please contact info</span>&nbsp;<span class="contact-item-wmp">contact@lucida.fund</span><br />
                    <span>Exceptional people should contact</span>&nbsp;<span class="contact-item-wmp">work@lucida.fund</span>
                </div>
            </div>
        </div>
        <div class="article" ref="ArticleScroll" @scroll="handleScroll()">
            <div class="article-t1">Stay on top of crypto.</div>
            <div class="article-t2">All the time,<br />Any time.</div>
            <div class="article-content">
                Please keep me updated by email with the latest crypto news, research findings, reward programs, event updates, coin listings and more information from LUCIDA.
            </div>
            <div class="subscribe-email">
                <input v-model="email" type="email" placeholder="Enter your e-mail address">
                <button @click="subscribe">Subscribe</button>
            </div>
            <div v-for="articleItem, keyItem in articleMap" :key="'articleMap_'+keyItem">
                <div class="article-type">{{ keyItem }}</div>
                <div class="article-skeleton" v-if="articleItem.length === 0">
                    <div class="cover-skeleton">
                        <img src="../../assets/image/index_v2/cover_load.svg" alt="">
                    </div>
                    <div class="title-skeleton"></div>
                    <div class="date-skeleton"></div>
                    <div class="abstract-skeleton"></div>
                </div>
                <div class="article-first" v-else>
                    <div v-if="articleItem[0].cover.length === 1" class="article-cover">
                        <img :src="getCoverPath(articleItem[0].cover[0])" alt=""
                        @click="goto_url(articleItem[0].articleList[0].defaultLink)">
                    </div>
                    <div v-else class="cover-container">
                        <div class="cover-images">
                            <img :src="getCoverPath(articleItem[0].cover[0])" alt=""
                            @click="goto_url(articleItem[0].articleList[0].defaultLink)">
                            <img :src="getCoverPath(articleItem[0].cover[1])" alt=""
                            @click="goto_url(articleItem[0].articleList[1].defaultLink)">
                            <img :src="getCoverPath(articleItem[0].cover[0])" alt=""
                            @click="goto_url(articleItem[0].articleList[0].defaultLink)">
                        </div>
                    </div>
                    <div v-if="articleItem[0].articleList.length === 1" class="article-info">
                        <div class="article-title" @click="goto_url(articleItem[0].articleList[0].defaultLink)">
                            {{ articleItem[0].articleList[0].title }}
                        </div>
                        <div class="article-date">
                            {{ dateStrFormat(articleItem[0].articleList[0].releaseDate) }}
                            <div class="article-reprint">
                                <img v-for="linkItem, index in articleItem[0].articleList[0].linkList"
                                :key="'Research' + articleItem[0].articleList[0].id + '-linkList-' + index"
                                @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                            </div>
                        </div>
                        <div class="article-abstract">{{ articleItem[0].articleList[0].articleAbstract }}</div>
                    </div>
                    <div v-else class="article-info">
                        <div class="article-title" @click="goto_url(articleItem[0].articleList[0].defaultLink)">
                            {{ articleItem[0].articleList[0].title }}
                        </div>
                        <div class="article-reprint">
                            <img v-for="linkItem, index in articleItem[0].articleList[0].linkList"
                            :key="'Research' + articleItem[0].articleList[0].id + '-linkList-' + index"
                            @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                        </div>
                        <div class="article-title-2" @click="goto_url(articleItem[0].articleList[1].defaultLink)">
                            {{ articleItem[0].articleList[1].title }}
                        </div>
                        <div class="article-reprint">
                            <img v-for="linkItem, index in articleItem[0].articleList[1].linkList"
                            :key="'Research' + articleItem[0].articleList[1].id + '-linkList-' + index"
                            @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                        </div>
                        <div class="article-date">
                            {{ dateStrFormat(articleItem[0].articleList[1].releaseDate) }}
                        </div>
                    </div>
                </div>
                <div class="article-flow">
                    <div class="article-item" v-for="groupItem in articleItem.slice(1)" :key="'Research_Group_' + groupItem.groupId">
                        <div v-if="groupItem.cover.length === 1" class="article-cover">
                            <img :src="getCoverPath(groupItem.cover[0])" alt=""
                            @click="goto_url(groupItem.articleList[0].defaultLink)">
                        </div>
                        <div v-else class="cover-container">
                            <div class="cover-images">
                                <img :src="getCoverPath(groupItem.cover[0])" alt=""
                                @click="goto_url(groupItem.articleList[0].defaultLink)">
                                <img :src="getCoverPath(groupItem.cover[1])" alt=""
                                @click="goto_url(groupItem.articleList[1].defaultLink)">
                                <img :src="getCoverPath(groupItem.cover[0])" alt=""
                                @click="goto_url(groupItem.articleList[0].defaultLink)">
                            </div>
                        </div>
                        <div v-if="groupItem.articleList.length === 1" class="article-info">
                            <div class="article-title" @click="goto_url(groupItem.articleList[0].defaultLink)">
                                {{ groupItem.articleList[0].title }}
                            </div>
                            <div class="article-date">
                                {{ dateStrFormat(groupItem.articleList[0].releaseDate) }}
                                <div class="article-reprint">
                                    <img v-for="linkItem, index in groupItem.articleList[0].linkList"
                                    :key="'Research' + groupItem.articleList[0].id + '-linkList-' + index"
                                    @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                                </div>
                            </div>
                            <div class="article-abstract">{{ groupItem.articleList[0].articleAbstract }}</div>
                        </div>
                        <div v-else class="article-info">
                            <div class="article-title" @click="goto_url(groupItem.articleList[0].defaultLink)">{{ groupItem.articleList[0].title }}</div>
                            <div class="article-reprint">
                                <img v-for="linkItem, index in groupItem.articleList[0].linkList"
                                :key="'Research' + groupItem.articleList[0].id + '-linkList-' + index"
                                @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                            </div>
                            <div class="article-title-2" @click="goto_url(groupItem.articleList[1].defaultLink)">{{ groupItem.articleList[1].title }}</div>
                            <div class="article-reprint">
                                <img v-for="linkItem, index in groupItem.articleList[1].linkList"
                                :key="'Research' + groupItem.articleList[1].id + '-linkList-' + index"
                                @click="goto_url(linkItem.link)" :src="getCoverPath(linkItem.logo)" alt="">
                            </div>
                            <div class="article-date">
                                {{ dateStrFormat(groupItem.articleList[1].releaseDate) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isLastPage(keyItem)" class="more-article" @click="loadMoreArticle(keyItem)">Load more...</div>
            </div>
            <div class="bottom-null-box"></div>
            <div class="bottom-box-2">
                <div class="btmlink-mp">
                    <span class="copyright">Copyright 2025</span>
                    <img class="jump-to-1" src="../../assets/image/index_v2/Group 27153.svg" alt="">
                    <img class="jump-to-2" src="../../assets/image/index_v2/Group 27154.svg" alt="">
                    <img class="jump-to-3" src="../../assets/image/index_v2/Group 27157.svg" alt="">
                    <img class="jump-to-4" src="../../assets/image/index_v2/Group 27156.svg" alt="">
                    <img class="jump-to-5" src="../../assets/image/index_v2/Group 27158.svg" alt="">
                </div>
            </div>
        </div>
        <div class="bottom-box">
            <div class="line-mp"></div>
            <div class="bottom-info-mp">
                <div class="btminfo-mp">
                    Lucida's funds are registered in the Cayman Islands.<br />
                    Lucida does not solicit or accept retail investment.<br />
                    <hr>
                </div>
            </div>
            <div class="btmlink-mp">
                <span class="copyright">Copyright 2025</span>
                <img class="jump-to-1" src="../../assets/image/index_v2/Group 27153.svg" alt="">
                <img class="jump-to-2" src="../../assets/image/index_v2/Group 27154.svg" alt="">
                <img class="jump-to-3" src="../../assets/image/index_v2/Group 27157.svg" alt="">
                <img class="jump-to-4" src="../../assets/image/index_v2/Group 27156.svg" alt="">
                <img class="jump-to-5" src="../../assets/image/index_v2/Group 27158.svg" alt="">
            </div>
        </div>
    </div>
</template>

<style scoped>
    @font-face {
        font-family: "MiSans-Bold";
        src: url("../../assets/fonts/index_v2/MiSans/ttf/MiSans-Bold.ttf");
    }
    @font-face {
        font-family: "MiSans-Regular";
        src: url("../../assets/fonts/index_v2/MiSans/ttf/MiSans-Regular.ttf");
    }
    .container-mp {
        position: relative;
        height: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .main-box-mp {
        position: relative;
        height: 72%;
        margin: 0px 16px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .lucida-icon-mp{
        position: absolute;
        top: 24px;
        left: 16px;
    }
    .lucida-icon-mp>img{
        width: 100px;
    }
    .title-mp {
        font-family: MiSans-Bold;
        font-size: 46px;
        transition: transform 0.5s ease, opacity 0.5s ease;
    }
    .title-mp>div{
        display: flex;
        align-items: center;
        overflow: hidden;
    }
    .user-info-mp{
        font-family: MiSans-Regular;
        position: absolute;
        right: 0px;
        bottom: 65px;
        text-align: right;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .info-item-mp{
        margin-top: 16px;
        font-size: 16px;
        line-height: 16px;
    }
    .contact-info-mp{
        position: absolute;
        left: 0px;
        bottom: 0px;
        font-size: 12px;
        margin-top: 20px;
        padding-left: 6px;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .contact-item-mp{
        font-family: MiSans-Regular;
        line-height: 16px;
    }
    .contact-item-wmp{
        font-size: 16px;
        text-decoration: underline;
    }
    .line-left-mp{
        width: 1px;
        height: 72px;
        position: absolute;
        bottom: 0px;
        left: 0;
        background-color: #fff9;
    }
    .emphasize-mp{
        background-color: #0045FF;
    }
    .line-mp{
        height: 1px;
        background-color: #fffa;
    }
    .bottom-box{
        position: absolute;
        width: 100%;
        bottom: 4px;
        transition: opacity 0.5s ease;
    }
    .bottom-box>div{
        margin: 0px 16px;
    }
    hr {
        background-color: #fffa;
        height: 1px;
        border: none;
    }
    .bottom-info-mp{
        display: flex;
        justify-content: right;
        padding-top: 4px;
    }
    .btminfo-mp{
        font-family: MiSans-Regular;
        font-size: 10px;
        line-height: 14px;
        display: inline-block;
        text-align: right;
    }
    .btmlink-mp{
        position: relative;
        display: flex;
        justify-content: center;
        margin-bottom: 14px;
    }
    .btmlink-mp>img{
        margin: 6px;
        width: 24px;
    }
    .copyright{
        font-family: MiSans-Regular;
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 10px;
        opacity: .6;
    }
    .article {
        font-family: MiSans-Regular;
        position: absolute;
        top: 70px;
        margin: 0px 16px;
        display: none;
        opacity: 0;
        width: calc(100% - 32px);
        height: 100%;
        overflow-y: scroll;
        transition: opacity 0.5s ease;
    }
    .article::-webkit-scrollbar {
        display: none;
    }
    .article-t1, .article-t2{
        font-family: MiSans-Bold;
    }
    .article-t1{
        font-size: 30px;
    }
    .article-t2{
        font-size: 36px;
    }
    .article-content{
        font-size: 14px;
        margin: 20px 0px;
    }
    .subscribe-email{
        display: flex;
        justify-content: center;
        gap: 8px;
    }
    .subscribe-email>input{
        outline: none;
        padding: 0px 10px;
        border: none;
        flex: 2;
        height: 40px;
        border-radius: 8px;
        color: #909090;
        background-color: #d9d9d9;
    }
    .subscribe-email>button{
        height: 40px;
        padding: 0;
        flex: 1;
        color: #fff;
        border: none;
        border-radius: 8px;
        background-color: #0045FF;
    }
    .article-type{
        height: 80px;
        line-height: 100px;
        font-size: 28px;
        font-family: MiSans-Bold;
    }
    .article-first{
        margin-bottom: 16px;
    }
    .cover-skeleton{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        border-radius: 8px;
        background-color: #666;
    }
    .cover-skeleton>img{
        width: 30px;
        height: 30px;
    }
    .article-skeleton{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .title-skeleton, .abstract-skeleton, .date-skeleton{
        height: 12px;
        border-radius: 4px;
        background-color: #666
    }
    .title-skeleton {
        height: 16px;
    }
    .date-skeleton{
        width: 70%;
    }
    .article-cover{
        border: 1px solid #fff;
        border-radius: 8px;
        overflow: hidden;
    }
    .article-cover>img{
        width: 100%;
    }
    .cover-container{
        overflow: hidden;
        border-radius: 10px;
        border: 1px solid #fff;
    }
    .article-first > .cover-container,
    .article-first > .article-info{
        width: calc(100% - 2px);
    }
    .cover-images{
        width: 300%;
        animation: move 12s infinite;
    }
    .cover-images>img{
        width: 160px;
        height: 80px;
        float: left;
    }
    .article-title{
        font-size: 14px;
        line-height: 18px;
        margin-top: 8px;
    }
    .article-title-2{
        font-size: 14px;
        line-height: 18px;
        margin-top: 4px;
    }
    .article-date, .article-abstract{
        font-size: 10px;
        line-height: 14px;
        margin-top: 4px;
    }
    .article-date {
        display: flex;
        align-items: center;
    }
    .article-date>.article-reprint{
        margin-left: 4px;
    }
    .article-reprint{
        display: flex;
        align-items: center;
        margin: 2px 0;
        gap: 4px;
    }
    .article-reprint img{
        width: 14px;
        height: 14px;
    }
    .article-flow{
        column-count: 2;
        gap: 20px;
    }
    .article-item {
        break-inside: avoid;
        margin-bottom: 16px;
    }
    .more-article{
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 12px;
    }
    .bottom-null-box{
        height: 40px;
    }
    .bottom-box-2{
        width: 100%;
        margin-bottom: 84px;
    }
    @keyframes move{
        0%,30%{
            margin-left: 0px;
        }
        35%,65%{
            margin-left: -100%;
        }
        70%,100%{
            margin-left: -200%;
        }
    }
    @media screen and (max-width:390px){
        .title-mp {
            font-size: 36px;
        }
        .contact-item-wmp{
            font-size: 14px;
        }
    }
    @media screen and (max-height:760px){
        .info-item-mp {
            margin-top: 8px;
        }
    }
</style>

<script>
export default {
  data() {
    return {
        pageCount: 0,
        pageTotal: 3,
        startX: 0,
        startY: 0,
        timerId: null,
        email: "",
        articleListMap: {
            "Research": [],
            "AMA & Podcast": [],
            "Market View": []
        },
        articleMap: {
            "Research": [],
            "AMA & Podcast": [],
            "Market View": []
        },
        articleListParam: {
            "Research": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
            "AMA & Podcast": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
            "Market View": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
        },
        ASTarget: true
    };
  },
  watch: {
    email(newValue, oldValue){
        let btnDom = document.querySelector(".subscribe-email button");
        btnDom.innerHTML = "Subscribe";
        btnDom.style.backgroundColor = "#0045FF";
        btnDom.style.color = "#fff";
    },
    pageCount(newValue, oldValue) {
        let title = document.querySelector('.title-mp');
        let userInfo = document.querySelector('.user-info-mp');
        let contactInfo = document.querySelector('.contact-info-mp');
        let article = document.querySelector('.article');
        let bottom_box = document.querySelector('.bottom-box');
        let state = oldValue + "->" + newValue;
        switch (state) {
            case "0->1": {
                let h = document.body.clientHeight * 0.2;
                title.style.transform = `translateY(-${h}px)`;
                title.style.opacity = '0.5';
                userInfo.style.opacity = '1';
                contactInfo.style.opacity = '1';
                break;
            }
            case "1->2": {
                title.style.opacity = '0';
                userInfo.style.opacity = '0';
                contactInfo.style.opacity = '0';
                bottom_box.style.opacity = '0';
                setTimeout(() => {
                    title.style.display = 'none';
                    userInfo.style.display = 'none';
                    contactInfo.style.display = 'none';
                    setTimeout(() => {
                        article.style.display = 'block';
                        setTimeout(() => {
                            this.calculateSize();
                            article.style.opacity = '1';
                        }, 10);
                    }, 10);
                }, 500);
                break;
            }
            case "1->0": {
                title.style.transform = 'translateY(0)';
                title.style.opacity = '1';
                userInfo.style.opacity = '0';
                contactInfo.style.opacity = '0';
                break;
            }
            case "2->1": {
                article.style.opacity = '0';
                setTimeout(() => {
                    article.style.display = 'none';
                    title.style.display = 'block';
                    userInfo.style.display = 'block';
                    contactInfo.style.display = 'block';
                    setTimeout(() => {
                        title.style.opacity = '0.5';
                        userInfo.style.opacity = '1';
                        contactInfo.style.opacity = '1';
                        bottom_box.style.opacity = '1';
                    }, 10);
                }, 500);
                break;
            }
        }
    },
  },
  methods: {
    touchStartHandler(e) {
        if (this.pageCount !== 2) e.preventDefault();
        this.startX = e.changedTouches[0].pageX,
        this.startY = e.changedTouches[0].pageY;
    },
    touchEndHandler(e) {
        switch (e.target.className) {
            case 'jump-to-1':
            window.open('https://x.com/lucidafund');
                break;
            case 'jump-to-2':
            window.open('https://mirror.xyz/lucidafund.eth');
                break;
            case 'jump-to-3':
            window.open('https://www.linkedin.com/company/81970900');
                break;
            case 'jump-to-4':
            window.open('https://medium.com/@Lucida_and_Falcon');
                break;
            case 'jump-to-5':
            window.open('https://github.com/lucidagithub');
                break;
            default:
                break;
        }
        let x = e.changedTouches[0].pageX - this.startX;
        let y = e.changedTouches[0].pageY - this.startY;
        let abs_x = (x > 0 ? x : -x);
        let abs_y = (y > 0 ? y : -y);
        // 当 |y| > |x| 时，为上/下滑 ( |y|必需大于最小滑动值 )
        if(abs_y > abs_x && abs_y > 30 && this.timerId === null) {
            if(this.pageCount === 2 && this.ASTarget) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 500);
                this.pageCount--;
            }
            else if(y < 0 && this.pageCount !== 2 && this.pageCount < (this.pageTotal - 1)) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 500);
                this.pageCount++;
            }
            else if(y > 0 && this.pageCount !== 2 && this.pageCount > 0) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 500);
                this.pageCount--;
            }
        }
    },
    subscribe(){
        if (!this.email) return;
        this.request({
            method: 'POST',
            url: '/mail_push/subscribe',
            data: {
                email: this.email
            }
        }).then((res)=>{
            let btnDom = document.querySelector(".subscribe-email button");
            if(res.data.code === 200) {
                btnDom.innerHTML = "Subscribed";
                btnDom.style.backgroundColor = "#fff";
                btnDom.style.color = "#000";
            } else if(res.data.code === 202) {
                btnDom.innerHTML = "Duplicate<br/>Subscription";
                btnDom.style.backgroundColor = "#515151";
                btnDom.style.color = "#fff";
            }
        });
    },
    whoIsZh(text1,text2){
        const t1 = (text1.match(/[\u4e00-\u9fa5]/g) || []).length;
        const t2 = (text2.match(/[\u4e00-\u9fa5]/g) || []).length;
        if(t1 > t2) return 0;
        else return 1;
    },
    goto_url(url) {
        if(url) window.open(url);
    },
    handleScroll(){
        let container = this.$refs.ArticleScroll;
        if(container.scrollTop === 0){
            setTimeout(() => {
                this.ASTarget = true;
            }, 100);
        }else{
            this.ASTarget = false;
        }
    },
    getCoverPath(path) {
        return this.fileServer + "/article" + path;
    },
    dateStrFormat(dateStr){
        let ymd = dateStr.split(" ")[0].split("-");
        return `${ymd[2]}/${ymd[1]}/${ymd[0]}`;
    },
    stringToDate(dateStr) {
        return new Date(dateStr);
    },
    articleGroup(articleList) {
        let _articleList = articleList.sort((a, b) => this.stringToDate(b.releaseDate) - this.stringToDate(a.releaseDate));
        let articleGroupData = {};
        for(let item of _articleList) {
            let key = '' + item.groupId;
            if(!articleGroupData[key]) {
                articleGroupData[key] = {
                    "groupId": item.groupId,
                    "cover": [],
                    "articleList": []
                };
            }
            articleGroupData[key]["cover"].push(item.cover);
            articleGroupData[key]["articleList"].push(item);
        }
        let articleGroupList = Object.values(articleGroupData);
        // 强制将英文文章排在上面
        let temp, i, j;
        for(i in articleGroupList) {
            if(articleGroupList[i]['articleList'].length === 2){
                j = this.whoIsZh(
                    articleGroupList[i]['articleList'][0].articleAbstract,
                    articleGroupList[i]['articleList'][1].articleAbstract
                );
                // 交换位置
                if (j === 0) {
                    temp = articleGroupList[i]['cover'][0];
                    articleGroupList[i]['cover'][0] = articleGroupList[i]['cover'][1];
                    articleGroupList[i]['cover'][1] = temp;
                    temp = articleGroupList[i]['articleList'][0];
                    articleGroupList[i]['articleList'][0] = articleGroupList[i]['articleList'][1];
                    articleGroupList[i]['articleList'][1] = temp;
                }
            }
        }
        // 分组排序
        articleGroupList = articleGroupList.sort((a, b) => this.stringToDate(b.articleList[1].releaseDate) - this.stringToDate(a.articleList[1].releaseDate));
        return articleGroupList;
    },
    isLastPage(type) {
        let param = this.articleListParam[type];
        switch (type) {
            case "Research":
                return (this.articleListMap['Research'].length+1) >= param.total;
            case "AMA & Podcast":
                return (this.articleListMap['AMA & Podcast'].length+1) >= param.total;
            default:
                return true;
        }
    },
    calculateSize(){
        let mainDom = document.querySelector('.article');
        let domList = document.querySelectorAll('.article-first .cover-images>img');
        let width, dom;
        if(mainDom!==null && domList.length !== 0){
            width = mainDom.offsetWidth - 2;
            for(dom of domList) {
                dom.style.width = width + 'px';
                dom.style.height = (width / 2) + 'px';
            }
        }
        mainDom = document.querySelector('.article-flow .cover-container');
        domList = document.querySelectorAll('.article-flow .cover-images>img');
        if(mainDom!==null && domList.length !== 0){
            width = mainDom.offsetWidth - 2;
            for(dom of domList) {
                dom.style.width = width + 'px';
                dom.style.height = (width / 2) + 'px';
            }
        }
    },
    loadMoreArticle(type) {
        if(type === '' || this.isLastPage(type)) return;
        this.articleListParam[type].currentPage++;
        let params = {
            type: type,
            currentPage: this.articleListParam[type].currentPage,
            pageSize: this.articleListParam[type].pageSize
        }
        this.getArticleList(params);
    },
    async getArticleList(params){
        let state = this.articleListParam[params.type].state;
        if(state) return;
        this.articleListParam[params.type].state = 1;
        await this.request({
            method: 'GET',
            url: '/article/getArticleList',
            params: params
        }).then((res)=>{
            if(res.data.code===200) {
                let dataList = res.data.data;
                let Market_View_Data;
                for(let index in dataList) {
                    dataList[index].linkList = JSON.parse(dataList[index].linkUrl);
                }
                switch (params.type) {
                    case "Research":
                        this.articleListMap['Research'] = this.articleListMap['Research'].concat(dataList);
                        this.articleMap['Research'] = this.articleMap['Research'].concat(this.articleGroup(dataList));
                        break;
                    case "AMA & Podcast":
                        this.articleListMap['AMA & Podcast'] = this.articleListMap['AMA & Podcast'].concat(dataList);
                        this.articleMap["AMA & Podcast"] = this.articleMap["AMA & Podcast"].concat(this.articleGroup(dataList));
                        break;
                    case "Market View":
                        this.articleListMap['Market View'] = this.articleListMap['Market View'].concat(dataList);
                        Market_View_Data = this.articleMap["Market View"].concat(this.articleGroup(dataList));
                        this.articleMap["Market View"] = [Market_View_Data[0]];
                        break;
                    default:
                        break;
                }
                setTimeout(() => {
                    this.calculateSize();
                }, 10);
            }
        });
        await this.request({
            method: 'GET',
            url: '/article/getArticleCount',
            params: {
                type: params.type
            }
        }).then((res)=>{
            this.articleListParam[params.type].total = res.data.data;
        });
        let type = params.type;
        setTimeout(() => {
            this.articleListParam[type].state = 0;
        }, 500);
    },
  },
  async created() {
    await this.getArticleList({
        type: "Research",
        currentPage: 1,
        pageSize: this.articleListParam["Research"].pageSize
    });
    await this.getArticleList({
        type: "AMA & Podcast",
        currentPage: 1,
        pageSize: this.articleListParam["AMA & Podcast"].pageSize
    });
    await this.getArticleList({
        type: "Market View",
        currentPage: 1,
        pageSize: this.articleListParam["Market View"].pageSize
    });
  }
};
</script>